<template>
    <div>

        <div id="speaker" class="modal">
            <div class="modal-contents" id="speakerScroll">
                <div class="row margin0">
                    <div class="col-lg-6 col-md-6 noPadding">
                        <div class="ts-speaker-popup-img">
                            <img :src="data.image" v-if="data.image">
                            <img src="images/user_avatar.png" v-else>
                            <!--<img src="{{speaker_image_fake}}">-->
                        </div>
                    </div><!-- col end-->
                    <div class="col-lg-6 col-md-6 noPadding">
                        <div class="ts-speaker-popup-content">
                            <h3 class="ts-title">{{data.fullname}}</h3>

                            <span class="speaker-designation">{{data.designation}}</span>
                            <img class="company-logo" :src="data.logo" v-if="data.logo">
                            <span class="speaker-designation" v-html="data.org_name"></span>
                            <p v-if="data.description" v-html="data.description"></p>
                            <span class="speaker-heading" v-if="data.speakerExpertises">Area Of Expertise</span>
                            <span class="speaker-expertise speaker-designation">
                                <ul v-if="data.speakerExpertises">
                                    <li v-for="s in data.speakerExpertises">{{s.skill}}</li>
                                </ul>
                            </span>
                            <div class="ts-speakers-social">
                                <a :href="'https://www.facebook.com/'+data.facebook" v-if="data.facebook" target="_blank"><i class="fab fa-facebook-f"></i></a>
                                <a :href="'https://twitter.com/'+data.twitter" v-if="data.twitter" target="_blank"><i class="fab fa-twitter"></i></a>
                                <a :href="'https://www.instagram.com/' + data.instagram" v-if="data.instagram" target="_blank"><i class="fab fa-instagram"></i></a>
                                <a :href="'https://www.linkedin.com/in'+data.linkedin" v-if="data.linkedin" target="_blank"><i class="fab fa-linkedin-in"></i></a>
                            </div>
                        </div><!-- ts-speaker-popup-content end-->
                    </div><!-- col end-->
                </div><!-- row end-->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function(){
            return {
                data: [],
            };
        },
        methods:{
            getSpeakerData(){
                this.data = this.$parent.speaker_data;
            }
        },
        mounted(){
            // var t = this;
            // setInterval(function () {
            //     var data = t.$parent.speakerData;
            //     // console.log(data.speaker_data);
            // }, 5000)

            $('#speakerScroll').perfectScrollbar();
        }
    }
</script>

<style scoped>
       .modal-contents {
        overflow: hidden !important;
        position: relative;
        background-color: #fff;
    }

    #speaker .modal-contents{
    }
    @media screen and (max-width:1200px ){
        #speakerScroll{
            overflow: hidden;
        }
    }
    .ts-speaker-popup-img img {
        width: 100%;
    }

    .ts-speaker-popup-content {
        font-family: roboto;
        text-align: center;
    }

    .ts-speaker-popup-content .ts-title {
        margin-bottom: 0px;
        text-transform: capitalize;
    }

    .ts-speaker-popup-content .speaker-designation {
        display: block;
        font-size: 14px;
        margin-bottom: 20px;
        text-transform: capitalize;
    }

    .ts-speaker-popup-content .company-logo {
        margin-bottom: 0px;
    }

    .ts-speaker-popup-content p {
        margin-bottom: 25px;
    }

    .ts-speaker-popup-content h4 {
        font-size: 20px;
        font-weight: 700;
    }

    .ts-speaker-popup-content .session-name {
        margin-bottom: 15px;
    }

    .ts-speaker-popup-content .speaker-session-info p {
        color: #e7015e;
        margin-bottom: 30px;
    }

    .ts-speaker-popup-content .ts-speakers-social a {
        color: #ababab;
        margin: 0 15px;
    }

    .ts-speaker-popup-content .ts-speakers-social a:hover {
        color: #e7015e;
    }

    .ts-speaker-popup button.mfp-close {
        font-size: 30px;
    }
    #speakerScroll .modal-contents{
        overflow-x: hidden !important;
    }
    #speakerScroll .ps-scrollbar-x-rail{
        display: none !important;
    }
    .margin0{
        margin-left: 0px !important;
        margin-right: 0px !important;
    }
    .noPadding{
        padding-right: 0px !important;
        padding-left: 0px !important;
    }
    .speaker-expertise ul li{
        display: inline;
        padding: 0 3px;
    }
    .speaker-expertise ul li:after {
        content: ", ";
    }
    .speaker-expertise ul li:last-child:after {
        content: "";
    }
</style>